import { render } from "./SNotice.vue?vue&type=template&id=476e8594&scoped=true&ts=true"
import script from "./SNotice.vue?vue&type=script&lang=ts"
export * from "./SNotice.vue?vue&type=script&lang=ts"

import "./SNotice.vue?vue&type=style&index=0&id=476e8594&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.2.2_@vue+compiler-sfc@3.3.4_vue@3.3.4_webpack@5.88.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-476e8594"]])

export default __exports__